import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core'
import { List, Map } from 'immutable'

@Component({
  selector: 'form-preview',
  templateUrl: './form-preview.component.html',
  styleUrls: ['./form-preview.component.css'],
})
export class FormPreviewComponent implements OnInit {
  @Input() public rows: List<Map<string, any>>
  @Input() public values: Map<string, any>
  @Input() public activeForm: Map<string, any>
  @Input() public isReadonly = false
  @Output() onSelect: EventEmitter<any> = new EventEmitter()
  @Output() onSelectInput: EventEmitter<any> = new EventEmitter()
  @Output() onInput: EventEmitter<any> = new EventEmitter()
  constructor() {}

  ngOnInit() {}

  handleSelectChange(e: any) {
    this.onSelect.emit(e)
  }

  handleSelectInput(e: any) {
    this.onSelectInput.emit(e)
  }

  handleFieldChange(e: Event) {
    this.onInput.emit(e)
  }
}
